import { useDeviceBinding } from '../../hooks/useDeviceBinding';

// ---------------------------------------------------------------------------
// DeviceBindingBanner -- persistent, NON-DISMISSABLE indicator shown
// whenever a bound device_token is active in the current browser session.
//
// plan-responsekit-2026-08-02-member-location-tracking.md, Approach §5
// (IAM-03(b)), Execution step 10.
//
// Deliberately has no close/dismiss control -- a crew member using a bound
// browser must not be able to hide the fact that location is always
// reported, regardless of their personal preference toggles.
// ---------------------------------------------------------------------------

export default function DeviceBindingBanner() {
  const { isBound, vehicleId } = useDeviceBinding();

  if (!isBound) return null;

  return (
    <div style={bannerStyle} role="status">
      <span style={{ fontSize: 14 }}>📍</span>
      <span>
        This device is bound to Vehicle {vehicleId ?? 'unknown'} — location is
        always reported.
      </span>
    </div>
  );
}

const bannerStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: '6px 12px',
  background: '#7c2d12',
  color: '#fff',
  fontSize: 12,
  fontWeight: 600,
  width: '100%',
  boxSizing: 'border-box',
};
